import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import "./CSS/WelcomeComponent.css";
import logo from "../Assets/logo-heedify-nav.avif";
const WelcomeComponent = () => {
  const { instance } = useMsal();
  const { t } = useTranslation();
  // Handle login button click
  const handleLogin = () => {
    instance
      .handleRedirectPromise()
      .then((result) => {
        if (!result) {
          instance.loginRedirect();
        }
      })
      .catch((error) => {
        console.error("Error during handleRedirectPromise:", error);
        // Optionally, you can retry login or handle errors here
      });
  };

  return (
    <div className="container">
      <img src={logo} alt="Heedify Logo" className="image" />
      <h2 className="subtitle">{t("WELCOME.TITLE")} </h2>
      <p className="paragraph">{t("WELCOME.PARAGRAPH")}</p>
      <Button onClick={handleLogin} className="button">
      {t("WELCOME.LOGIN_BUTTON")}
      </Button>
    </div>
  );
};

export default WelcomeComponent;
